module.exports = __webpack_public_path__ + "static/media/IMG_4293.ff0776be.PNG";